import { ZodTrimmedString } from '@Common/types/zod/zod-trimmed-string';

/**
 * Trimmed string without Cyrillic characters (U+0400-U+04FF).
 * Use this for text fields that should only contain Latin characters.
 */
export const ZodNoCyrillicString = ZodTrimmedString.regex(
  /^[^\u0400-\u04FF]*$/,
  'Cyrillic characters are not allowed',
);
